import styled from 'styled-components';
import { getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/core';

export const CodeElement = styled.code`
    ${getTextTokenPreset('bodyLarge')};
    word-break: break-word;
    padding: ${getSpacingToken('100')}px;
    display: block;
    background-color: ${getToken('backgroundInteractiveSecondaryDefault')};
    color: ${getToken('textStaticSecondary')};
    text-align: center;
`;
